/* eslint-disable object-shorthand */
import {
    AfterViewInit,
    Component,
    HostListener,
    NgZone,
    OnInit,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { NgForm, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {
    BasicFormFields,
    CommonService,
    Config,
    Destroy,
    FIELD_TYPE,
    FieldsService,
    FormBaseField,
    INPUT_MODE,
    MODALCONFIG,
    MODAL_SIZE,
    MODAL_TYPE,
    PasswordFormFields,
    SIDEDRAWERCONFIG,
    SIDEDRAWER_POSITION,
    SIDEDRAWER_SIZE,
    SIDEDRAWER_TYPE,
    SelectFormFields,
    SnackService,
    ToastService,
    rangeValidator,
} from '@increff/commons';
import { FilterPipe } from 'ngx-filter-pipe';
import papa from 'papaparse';
import { Observable, finalize, forkJoin, of, takeUntil } from 'rxjs';
import { PASSWORD_SETTINGS } from 'src/app/common/enums/password.class';
import {
    APPLICATION,
    APP_RESOURCE,
    APP_ROLE,
    DOMAIN_ROLE
} from 'src/app/common/interfaces/application.interface';
import {
    DOMAIN_SETTINGS,
    ORGANISATION,
    OpenRegistrationOrg,
} from 'src/app/common/interfaces/organisation.interface';
import {
    AUTHNZ,
    TEMPLATE_GUIDE,
    USER,
} from 'src/app/common/interfaces/user.interface';
import { ConfigService } from 'src/app/common/services';
import { ApplicationsService } from 'src/app/common/services/applications/applications.service';
import { ConstantsService } from 'src/app/common/services/constants/constants.service';
import { HelperService } from 'src/app/common/services/helper/helper.service';
import { OrganisationService } from 'src/app/common/services/organisation/organisation.service';
import { UsersService } from 'src/app/common/services/users/users.service';
import { DOMAIN_CONFIG } from '../../enums/settings.enum';
import {
    AUTHENTICATION,
    DOMAIN_DETAILS,
} from '../../interfaces/authentication.interface';
import { LOGIN_MODE } from '../../interfaces/login-mode.interface';
import { DOMAIN_RESOURCE } from '../../interfaces/resource.interface';
import { AuthNGuardService } from '../../services/authn-guard.service';
import { ManagementService } from '../../services/management/management.service';

@Component({
    selector: 'com-users',
    templateUrl: './users.component.html',
    styleUrls: [
        '../../../../assets/scss/custom-radio.scss',
        './users.component.scss',
        '../../../../assets/scss/custom-switch.scss',
    ],
    viewProviders: [Destroy],
})
export class UsersComponent implements OnInit, AfterViewInit {
    @ViewChild('crudActionsTemplateRef', { static: true })
    private crudActionsTemplateRef: TemplateRef<any>;
    @ViewChild('manageLoginModeSelectSpy')
    private manageLoginModeSelectSpy: HTMLSelectElement;
    searchText: string;

    activeTab: 'config' | 'migration' = 'config';

    addDomainResourceModalConfig: MODALCONFIG;
    addDomainResourceFormFields: FormBaseField[];
    addDomainResourceFormModel: {
        [key: string]: BasicFormFields | SelectFormFields;
    };

    addNewUserModalConfig: MODALCONFIG;
    addNewUserBasicDetailsFormFields: FormBaseField[];
    addNewUserPasswordFormFields: FormBaseField[];
    addNewUserBasicDetailsFormModel: {
        [key: string]: BasicFormFields | SelectFormFields;
    };
    addNewUserPasswordFormModel: { [key: string]: PasswordFormFields };

    bulkAddUsersModalConfig: MODALCONFIG;

    enableUserStateModalConfig: MODALCONFIG;
    disableUserStateModalConfig: MODALCONFIG;

    enableUserVerificationStatusModalConfig: MODALCONFIG;
    disableUserVerificationStatusModalConfig: MODALCONFIG;

    enabledUserMFAStatusModalConfig: MODALCONFIG;
    disableUserMFAStatusModalConfig: MODALCONFIG;

    updateUserDetailsModalConfig: MODALCONFIG;
    updateUserDetailsFormFields: FormBaseField[];
    updateUserDetailsFormModel: { [key: string]: BasicFormFields };

    manageUserLoginModeModalConfig: MODALCONFIG;
    manageUserLoginModeFormFields: FormBaseField[];
    manageUserLoginModeFormModel: {
        [key: string]: BasicFormFields | PasswordFormFields;
    };
    changeUserPasswordModalConfig: MODALCONFIG;
    changeUserPasswordFormFields: FormBaseField[];
    changeUserPasswordFormModel: { [key: string]: PasswordFormFields };

    resetUserModalConfig: MODALCONFIG;
    bulkUserDeletionModalConfig: MODALCONFIG;

    bulkAddUsersRolesModalConfig: MODALCONFIG;

    flow: 'admin' | 'domain' = 'admin';
    appName = '';
    domainId = -1;

    users: USER[] = [];
    searchResults: USER[] = [];
    selectedUser: USER;
    selectedUserStatus = 'enabled';
    userStatusList = ['enabled', 'disabled', 'system', 'admin'];
    applications: APPLICATION[] = [];
    applicationDomains: ORGANISATION[] | OpenRegistrationOrg[] = [];
    selectedApplicationDomain: ORGANISATION | OpenRegistrationOrg;

    allRoles: { [key: string | number]: APP_ROLE } = {};
    applicationResources: APP_RESOURCE[] = [];
    domainResourceMap: { [key: string]: DOMAIN_RESOURCE } = {};
    userRolesMap: { [key: string]: APP_ROLE } = {};

    isUserRolesLoaded: boolean = false;
    isDomainResourcesLoaded: boolean = false;

    resourceTypesSelectOptions: Array<{
        displayKey: string;
        valueKey: number;
    }> = [];

    loginModes: LOGIN_MODE[] = [];
    loginModeSelectOptions: Array<{ displayKey: string; valueKey: string }> =
        [];

    paginationParams: { pageNo: number; pageSize: number };
    filterColumns: Array<string> = ['fullName', 'username', 'email'];

    roleLevel: 'top' | 'resource' = 'top';
    domainResourceId = -1;
    appNamesMap: { [key: string | number]: APP_ROLE[] } = {};
    userRoles: DOMAIN_ROLE[] = [];
    rolesToBeShown: APP_ROLE[] = [];
    roleManagementModalConfig: MODALCONFIG;
    sessionData: AUTHENTICATION;

    bulkDeletionCsvErrors: Array<any> = [];
    bulkUserDeletionCsvLimit = 100;

    userMigrationTemplateGuide: TEMPLATE_GUIDE[] = [];
    bulkUpdateUsersTemplateGuide: TEMPLATE_GUIDE[] = [];
    bulkAddUsersTemplateGuide: TEMPLATE_GUIDE[] = [];

    domainSettingsDummy: DOMAIN_SETTINGS = {
        userLogoutDaysThreshold: undefined,
        userDisableDaysThreshold: undefined,
        verificationRequired: false,
        mfaVerificationRequired: false,
        allowedDomain: '',
    } as DOMAIN_SETTINGS;
    domainDetails: DOMAIN_DETAILS = {} as DOMAIN_DETAILS;
    domainSettingsModalConfig: SIDEDRAWERCONFIG;
    domainSettingsConfirmationModalConfig: MODALCONFIG;

    MAX_LOGOUT_DAYS = 30;
    MAX_DISABLE_DAYS = 180;

    applicationSelect: SelectFormFields = {
        key: 'applicationSelect',
        label: 'Application',
        type: FIELD_TYPE.CUSTOM_SELECT,
        required: true,
        disabled: !this.applications?.length,
        options: []
    };
    applicationDomainSelect: SelectFormFields = {
        key: 'applicationDomainSelect',
        label: 'Organisation',
        type: FIELD_TYPE.CUSTOM_SELECT,
        required: true,
        disabled: !this.applicationDomains?.length,
        options: []
    };

    smallScreen = false;

    constructor(
        private configService: ConfigService,
        private applicationService: ApplicationsService,
        private organisationService: OrganisationService,
        private constantsService: ConstantsService,
        private managementService: ManagementService,
        private readonly destroy$: Destroy,
        private commonService: CommonService,
        private activatedRoute: ActivatedRoute,
        private snackbar: SnackService,
        private toast: ToastService,
        private filterPipe: FilterPipe,
        public authService: AuthNGuardService,
        public userService: UsersService,
        public fieldsService: FieldsService,
        public helperService: HelperService,
        private config: Config,
        private zone: NgZone
    ) {
        void this.getLoginModes();
        void this.getSessionData();
        this.flow = this.activatedRoute?.snapshot?.data?.flow ?? 'admin';
        this.flow === 'admin'
            ? this.initialAdminFlowDataSetup()
            : this.initialDomainFlowDataSetup();
        this.getDomainDetails();
        this.getBulkUpdateUsersTemplateGuideData();
        this.onResize();
    }

    @HostListener('window:resize')
    onResize() {
        this.smallScreen = window.innerWidth < 768;
        this.setDomainSettingsModalData(!this.smallScreen);
    }

    ngOnInit(): void {
        this.setAddDomainResourceModalData();
        this.setAddNewUserModalData();
        this.setBulkUserDeletionModalData();
        this.setChangeUserStateModalData();
        this.setChangeUserVerificationStatusModalData();
        this.setChangeUserMFAStatusModalData();
        this.setUpdateUserDetailsModalData();
        this.setManageUserLoginModeModalData();
        this.setChangeUserPasswordModalData();
        this.setResetUserModalData();
        this.setRoleManagementModalData();
        this.setBulkAddUsersModalData();
        this.setDomainSettingsModalData(window.innerWidth > 768);

        if(this.flow !== 'admin') this.getUserRoles();
        else this.isDomainResourcesLoaded = true;
    }

    ngAfterViewInit(): void {
        this.configService.pageHeaderExtraTemplateRef =
            this.crudActionsTemplateRef;
        this.initTooltip();
        this.onResize();
    }

    initTooltip(): void {
        this.commonService?.initTooltip('com-users');
    }

    paginationHandler(value: any): void {
        this.paginationParams = value;
        this.initTooltip();
    }

    objectKeys(obj: object): Array<any> {
        return Object.keys(obj ?? {});
    }

    makeNumber(value: string): number {
        return Number(value);
    }

    getBulkUpdateUsersTemplateGuideData(): void {
        forkJoin([
            this.userService.getBulkAddUsersTemplateGuideData(),
            this.userService.getUserMigrationTemplateGuideData(),
            this.userService.getBulkUpdateUsersTemplateGuideData()
        ]).pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response)=> {
                    this.bulkAddUsersTemplateGuide = response?.[0] ?? [];
                    this.userMigrationTemplateGuide = response?.[1] ?? [];
                    this.bulkUpdateUsersTemplateGuide = response?.[2] ?? [];
                    setTimeout(() => {
                        this.initPopover();
                    });
                }
            });
    }

    async getLoginModes() {
        this.loginModes = await this.helperService?.getLoginModes();
        this.getLoginModeSelectOptions();
    }

    getSessionData() {
        this.authService
            ?.getSessionData$(this.activatedRoute?.snapshot)
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => this.initTooltip())
            )
            .subscribe({
                next: (response) => {
                    this.sessionData = response;
                },
            });
    }

    getDomainDetails(): void {
        this.authService
            ?.getDomainDetails(
                this.flow === 'admin'
                    ? (this.authService?.currentUser?.domainId as number)
                    : undefined,
                this.flow
            )
            .pipe(finalize(() => this.initTooltip()))
            .subscribe({
                next: (response) => {
                    this.domainDetails = response;
                },
            });
    }

    checkCreateDomainResourceRole(): boolean {
        return this.config?.startupData?.createDomainResourceRole?.some(
            (role) =>
                this.authService?.currentUser?.roles?.includes(role as string)
        );
    }

    initialAdminFlowDataSetup(): void {
        const fragmentData: any = this.activatedRoute?.snapshot?.fragment;
        if (!fragmentData?.appName || !fragmentData?.domainId) {
            const storageData = this.userService?.getAppDataFromStorage();
            this.appName = storageData?.appName;
            this.domainId = storageData?.domainId;
        } else
            (this.appName = fragmentData?.appName),
            (this.domainId = fragmentData?.domainId);
        this.userService?.setAppDataInStorage(this.appName, this.domainId);
        this.userStatusList?.pop();
        forkJoin([this.getApplications$(), this.getUsers$()]).subscribe({
            next: (response) => {
                this.applications = response?.[0];
                this.setApplicationSelectOptions();
                this.getApplicationDomains(this.appName);
                this.users = response?.[1];
                this.users = this.users?.filter((user) =>
                    this.selectedUserStatus === 'enabled'
                        ? user?.enabled && user?.authMode !== 'system'
                        : this.selectedUserStatus === 'disabled'
                            ? !user?.enabled && user?.authMode !== 'system'
                            : user?.authMode === 'system'
                );
            },
        });
    }

    initialDomainFlowDataSetup(): void {
        this.getUsers();
    }

    getApplications$(): Observable<APPLICATION[]> {
        return this.applicationService.getAllApplications().pipe(
            takeUntil(this.destroy$),
            finalize(() => this.initTooltip())
        );
    }

    setApplicationSelectOptions(): void {
        this.applicationSelect.options = this.applications?.map((appObj)=> ({displayKey: `${appObj?.fullName} (${appObj?.appName})`, valueKey: appObj?.appName}));
        this.applicationSelect.disabled = !this.applications?.length;
        this.applicationSelect.value = this.appName;
        this.applicationSelect = {...this.applicationSelect};
    }

    getApplicationDomains(appName: string): void {
        this.organisationService
            ?.getApplicationDomains(appName)
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => this.initTooltip())
            )
            .subscribe({
                next: (response) => {
                    this.applicationDomains = response;
                    this.setApplicationDomainSelectOptions();
                },
            });
    }

    setApplicationDomainSelectOptions(): void {
        this.applicationDomainSelect.options = this.applicationDomains?.map((orgObj)=> ({displayKey: orgObj?.domainName, valueKey: orgObj?.id}));
        this.applicationDomainSelect.disabled = !this.applicationDomains?.length;
        this.applicationDomainSelect.value = this.domainId;
        this.applicationDomainSelect = {...this.applicationDomainSelect};
    }

    getUsers$(): Observable<USER[]> {
        if (this.domainId == -1) return of([]);
        return this.userService?.getAllUsers(this.domainId, this.flow).pipe(
            takeUntil(this.destroy$),
            finalize(() => this.initTooltip())
        );
    }

    getUsers(): void {
        this.userService
            ?.getAllUsers(this.domainId, this.flow)
            .pipe(
                finalize(() => this.commonService?.initTooltip('com-users')),
                takeUntil(this.destroy$)
            )
            .subscribe({
                next: (response) => {
                    this.users = [...(response ?? [])];
                    this.users =
                        this.users?.filter((user) =>
                            this.selectedUserStatus === 'enabled'
                                ? user?.enabled && user?.authMode !== 'system'
                                : this.selectedUserStatus === 'disabled'
                                    ? !user?.enabled && user?.authMode !== 'system'
                                    : user?.authMode === 'system'
                        ) ?? [];
                    this.flow === 'domain' ? this.getDomainResources() : '';
                    this.searchData(this.searchText);
                },
            });
    }

    updateUserDetailsEmitterHandler(shallUpdateUser: boolean = true): void {
        if (shallUpdateUser)
            this.updateUserObjectById(
                Number(this.selectedUser['index']),
                this.selectedUser?.id,
                this.domainId
            );
        this.initTooltip();
    }

    updateUserObjectById(
        index: number,
        userId: number,
        domainId?: number
    ): void {
        this.userService
            ?.getUserDetailsById(userId, domainId, this.flow)
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => this.initTooltip())
            )
            .subscribe({
                next: (response) => {
                    const foundUserIndex = this.users
                        ?.slice(
                            (this.paginationParams?.pageNo - 1) *
                                this.paginationParams?.pageSize,
                            this.paginationParams?.pageNo *
                                this.paginationParams?.pageSize
                        )
                        ?.findIndex((userObj) => userObj?.id == userId);
                    if (foundUserIndex > -1) {
                        this.users[foundUserIndex] = { ...response };
                        if(this.selectedUserStatus === 'admin') this.users[foundUserIndex]['roles'] = [];
                    }
                    const foundSearchIndex = this.searchResults?.findIndex(
                        (user) => user?.id === userId
                    );
                    if (foundSearchIndex > -1) {
                        this.searchResults[foundSearchIndex] = { ...response };
                        if(this.selectedUserStatus === 'admin') this.users[foundUserIndex]['roles'] = [];
                        this.searchResults = [...(this.searchResults ?? [])];
                    }
                },
            });
    }

    getUsersForAdminTab(): void {
        this.userService
            ?.getUsersForSpecificResourceType(
                Number(
                    this.managementService?.appNamesMap?.[
                        this.flow === 'admin' ? this.appName : 'currentDomain'
                    ]?.['All']?.find(
                        (role) => role?.roleName === 'app.admin'
                    )?.['id']
                )
            )
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => this.initTooltip())
            )
            .subscribe({
                next: (response) => {
                    this.users = response;
                },
            });
    }

    getApplicationResources(domainResourceFormSetup: boolean = false): void {
        this.applicationService
            ?.getApplicationResources()
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => this.initTooltip())
            )
            .subscribe({
                next: (response) => {
                    this.applicationResources = response;
                    if (domainResourceFormSetup) {
                        this.resourceTypesSelectOptions = [];
                        this.applicationResources?.forEach((appResource) => {
                            this.resourceTypesSelectOptions?.push({
                                displayKey: appResource?.resource,
                                valueKey: appResource?.id,
                            });
                            this.addDomainResourceFormModel['resourceId'][
                                'options'
                            ] = this.resourceTypesSelectOptions;
                            this.addDomainResourceFormFields =
                                this.fieldsService?.getFormFields(
                                    this.addDomainResourceFormModel
                                );
                        });
                    }
                    this.flow === 'domain' ? this.getDomainResources() : '';
                },
            });
    }

    getDomainResources(): void {
        this.managementService
            ?.getAllDomainResources()
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => {this.initTooltip(); this.isDomainResourcesLoaded = true;})
            )
            .subscribe({
                next: (response) => {
                    const domainResourceList = response;
                    const domainResources: { [key: string]: DOMAIN_RESOURCE } = {};

                    domainResourceList?.forEach((domResource) => {
                        domainResources[domResource?.id] = domResource
                    });

                    this.domainResourceMap = domainResources;
                },
            });
    }

    getUserRoles(): void {
        this.isUserRolesLoaded = false;
        this.managementService
            ?.getAllUserRoles(this.appName, this.flow)
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => {this.initTooltip(); this.isUserRolesLoaded = true;})
            )
            .subscribe({
                next: (response) => {
                    const userRoles = response;
                    const roleMap: {[key: number]: APP_ROLE} = {};
                    userRoles?.forEach((role) => {
                        roleMap[role?.id] = role;
                    });
                    this.userRolesMap = roleMap;
                },
            });
    }

    addNewUser(
        basicDetailsForm: NgForm,
        authMode: string,
        passwordForm: NgForm,
        cancelBtn: HTMLButtonElement
    ): void {
        if (
            basicDetailsForm?.invalid ||
            (['basic', 'system']?.includes(authMode)
                ? passwordForm?.invalid
                : !authMode)
        ) {
            this.toast?.warn('Please fill all the required fields!');
            return;
        }

        this.userService
            ?.addNewUser(
                this.appName,
                this.domainId,
                {
                    ...basicDetailsForm?.value,
                    authMode: authMode,
                    ...passwordForm?.value,
                } as USER,
                this.flow
            )
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => this.initTooltip())
            )
            .subscribe({
                next: () => {
                    cancelBtn?.click();
                    this.getUsers();
                },
            });
    }

    createDomainResource(form: NgForm, cancelBtn: HTMLButtonElement): void {
        this.managementService
            ?.createDomainResource(form?.value as DOMAIN_RESOURCE)
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => this.initTooltip())
            )
            .subscribe({
                next: () => {
                    cancelBtn?.click();
                    // this.getDomainResources();
                    this.getApplicationResources();
                },
            });
    }

    changeUserState(arg1: any, cancelBtn: HTMLButtonElement): void {
        this.toast?.clear();
        this.userService
            ?.changeUserState(
                this.selectedUser?.id,
                this.domainId,
                !this.selectedUser?.enabled,
                this.flow
            )
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => this.initTooltip())
            )
            .subscribe({
                next: () => {
                    cancelBtn?.click();
                    this.selectedUserStatus === 'admin' ? this.getUsersForAdminTab() : this.getUsers();
                },
            });
    }

    changeUserVerificationStatus(
        arg1: any,
        cancelBtn: HTMLButtonElement
    ): void {
        this.toast?.clear();
        this.userService
            ?.changeUserVerificationStatus(
                this.selectedUser?.id,
                this.domainId,
                this.selectedUser?.verificationStatus === 'NOT_VERIFIED'
                    ? true
                    : false,
                this.flow
            )
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => this.initTooltip())
            )
            .subscribe({
                next: () => {
                    cancelBtn?.click();
                    this.getUsers();
                },
                error: () => {
                    setTimeout(() => {
                        this.snackbar?.clearUnauthorized();
                    }, 3000);
                },
            });
    }

    changeUserMFAStatus(
        arg1: any,
        cancelBtn: HTMLButtonElement
    ): void {
        this.toast?.clear();
        this.userService
            ?.changeUserMFAStatus(
                this.selectedUser?.id,
                this.domainId,
                !this.selectedUser?.mfaRequired,
                this.flow
            )
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => this.initTooltip())
            )
            .subscribe({
                next: () => {
                    cancelBtn?.click();
                    this.getUsers();
                },
                error: () => {
                    setTimeout(() => {
                        this.snackbar?.clearUnauthorized();
                    }, 3000);
                },
            });
    }

    updateUserDetails(form: NgForm, cancelBtn: HTMLButtonElement): void {
        if (form?.invalid) {
            this.toast?.warn('Please fill all the required fields!');
            return;
        }
        this.userService
            ?.updateUserDetails(
                this.selectedUser?.id,
                this.domainId,
                form?.value as USER,
                this.flow
            )
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => this.initTooltip())
            )
            .subscribe({
                next: () => {
                    cancelBtn?.click();
                    this.updateUserDetailsEmitterHandler();
                    // this.getUsers();
                },
            });
    }

    updateUserLoginMode(
        loginModeSelectSpy: HTMLSelectElement,
        form: NgForm,
        cancelBtn: HTMLButtonElement
    ): void {
        if (loginModeSelectSpy?.value === 'basic' ? form?.invalid : false) {
            this.toast?.warn('Please fill all the required fields!');
            return;
        }

        this.userService
            ?.changeUserLoginMode(
                this.selectedUser?.id,
                this.domainId,
                {
                    authMode: loginModeSelectSpy?.value,
                    ...form?.value,
                    userId: this.selectedUser?.id,
                } as AUTHNZ,
                this.flow
            )
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => this.initTooltip())
            )
            .subscribe({
                next: () => {
                    cancelBtn?.click();
                    this.updateUserDetailsEmitterHandler();
                },
            });
    }

    changeUserPassword(form: NgForm, cancelBtn: HTMLButtonElement): void {
        if (form?.invalid) {
            this.toast?.warn('Please fill all the required fields!');
            return;
        }

        this.userService
            ?.changeUserPassword(
                this.selectedUser?.id,
                form?.value?.password as string,
                this.flow,
                this.selectedUser?.domainId
            )
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => this.initTooltip())
            )
            .subscribe({
                next: () => {
                    cancelBtn?.click();
                    // this.getUsers();
                },
            });
    }

    resetUser(form: any, cancelBtn: HTMLButtonElement): void {
        if (form?.invalid) {
            this.toast?.warn('Please fill all the required fields!');
            return;
        }

        this.userService
            ?.resetUser(
                this.selectedUser?.id,
                this.selectedUser?.domainId,
                this.flow
            )
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => this.initTooltip())
            )
            .subscribe({
                next: () => {
                    cancelBtn?.click();
                    this.updateUserDetailsEmitterHandler();
                    // this.getUsers();
                },
            });
    }

    uploadUserDeletionFileSetup(
        fileSpy: any,
        cancelBtnSpy: HTMLButtonElement
    ): void {
        this.toast?.clear();
        const csvFile = fileSpy.valueAccessor._elementRef.nativeElement.files;
        if (!csvFile.length) {
            this.toast?.warn('CSV file is required!');
            return;
        }

        const fileExtension = csvFile[0].name.substring(
            csvFile[0].name.lastIndexOf('.') + 1
        );

        if (fileExtension.toLowerCase() !== 'csv') {
            this.toast?.warn('Only .csv format is supported!');
            return;
        }

        const config = {
            delimiter: ',',
            header: true,
            worker: true,
            escapeFormulae: true,
            error: () => {
                setTimeout(() => {
                    this.snackbar?.error();
                    this.toast?.warn(
                        'Error in Parsing CSV file. File was modified after attaching. Please re-attach the file.'
                    );
                });
            },
            complete: this.uploadUserDeletionFile.bind(
                this,
                fileSpy,
                cancelBtnSpy
            ),
        };

        this.toast?.clear();
        this.snackbar?.wait('Reading CSV File...');
        papa.parse(csvFile[0], config);
    }

    uploadUserDeletionFile(
        fileSpy: any,
        cancelBtnSpy: HTMLButtonElement,
        results: any
    ): void {
        this.bulkDeletionCsvErrors = [];
        if (results['errors']?.length) {
            fileSpy?.control?.reset();
            this.toast?.warn(
                'The CSV file has some errors! Please re-attach the file after fixing them.'
            );
            this.snackbar?.error('File has errors.');
            return;
        }

        const headers: string[] = ['email'];
        const headersFromFile: string[] = results?.['meta']?.['fields']
            ? results.meta.fields.map((headItem: string) =>
                (headItem + '').trim()
            )
            : [];

        if (!headersFromFile?.length) {
            fileSpy?.control?.reset();
            this.toast?.warn(
                'The CSV file is missing HEADERS, please re-attach the same file after providing HEADER row at the top.'
            );
            this.snackbar?.error('File has errors');
            return;
        }
        // Missing or wrong header check
        for (const item of headersFromFile)
            if (headers.indexOf(item) == -1) {
                fileSpy?.control?.reset();
                this.toast?.warn(
                    `The CSV file is missing HEADERS, please re-attach the same file after fixing them.`
                );
                this.snackbar?.error('File has errors');
                return;
            }
        // No data check
        if (!results['data'].length) {
            fileSpy?.control?.reset();
            this.toast?.warn('No data found in the selected file.');
            this.snackbar?.error('No data found!');
            return;
        }

        if (results?.['data']?.length > this.bulkUserDeletionCsvLimit) {
            fileSpy?.control?.reset();
            this.toast?.warn(
                'The file contains more data than the allowed limit! Please reduce the data and try again..'
            );
            this.snackbar?.error('Error');
            return;
        }
        // If a row has empty data under a column
        // eslint-disable-next-line guard-for-in
        for (const rowIndex in results['data']) {
            const row = results['data'][rowIndex];
            for (const header of headers)
                if (!row[header].trim())
                    this.bulkDeletionCsvErrors?.push({
                        email: row?.[header],
                        error: `At row ${Number(rowIndex) + 1}: Empty field`,
                    });
                else if (!(row[header] as string)?.endsWith('@increff.com'))
                    this.bulkDeletionCsvErrors?.push({
                        email: row?.[header],
                        error: `At row ${
                            Number(rowIndex) + 1
                        }: Only Increff organisation email is allowed`,
                    });
        }

        fileSpy?.control?.reset();
        this.snackbar?.clear();

        if (this.bulkDeletionCsvErrors?.length) {
            this.toast?.error({
                message: 'File has errors. Please correct them and try again',
            });
            return;
        }

        const mailIds: string[] = [];
        for (const obj of results?.['data'] ?? [])
            if (
                obj?.email?.trim() ===
                this.authService?.currentUser?.email?.trim()
            )
                this.toast?.warn(
                    `The file contains your own email address. The email address ${obj?.email?.trim()} has been ignored.`
                );
            else if (obj?.email?.trim()?.endsWith('@increff.com'))
                mailIds.push(obj?.email?.trim() as string);

        if (!mailIds?.length) {
            this.toast?.warn('No valid data is present in the file');
            return;
        }

        this.userService
            ?.deleteUsersByEmail(mailIds)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: () => {
                    this.selectedUserStatus === 'admin'
                        ? this.getUsersForAdminTab()
                        : this.getUsers();
                    cancelBtnSpy?.click();
                    this.bulkDeletionCsvErrors = [];
                },
            });
    }

    searchData(value: string): void {
        this.searchResults = [];
        const filterValue = {};
        const arr = [];
        for (const column of this.filterColumns) {
            const obj = {};
            obj[column] = value;
            arr?.push(obj);
        }
        filterValue['$or'] = [...arr];
        const tempArr = this.filterPipe?.transform(
            [...this.users],
            filterValue
        );
        this.searchResults = [...tempArr];
        this.initTooltip();
    }

    generateRandomPassword() {
        const len = 10;
        const charset =
            'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result: string | string[] = '';
        let specialChars: string | string[] = '!@#$';
        // eslint-disable-next-line no-constant-condition
        while (true) {
            result = '';
            for (let i = 0, n = charset.length; i < len; i++)
                result += charset.charAt(Math.floor(Math.random() * n));

            if (!/\d/.test(result)) continue;
            else break;
        }
        (result = result.split('')), (specialChars = specialChars.split(''));
        for (let i = 0; i < 2; i++) {
            const pos1 = Math.round(Math.random() * (result.length - 1));
            const pos2 = Math.round(Math.random() * (specialChars.length - 1));
            result[pos1] = specialChars[pos2];
        }
        result = result.join('');
        this.addNewUserPasswordFormFields = this.fieldsService?.getFormFields(
            this.addNewUserPasswordFormModel,
            { password: result, confirmPassword: result }
        );
        return result;
    }

    setDomainSettingsValue(): void {
        Object.keys(this.domainSettingsDummy)?.forEach((key) => {
            this.domainSettingsDummy[key] = this.domainDetails?.[key];
        });
        this.domainSettingsModalConfig['pillData'] =
            this.domainDetails?.domainName;
    }

    domainSettingsIntervention(controls: any, logoutDays: number): void {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        controls?.userDisableDaysThreshold?.setValidators([ Validators.required, rangeValidator( logoutDays > this.MAX_LOGOUT_DAYS ? this.MAX_LOGOUT_DAYS + 1 : logoutDays < 0 ? 0 : Number(logoutDays) + 1, this.MAX_DISABLE_DAYS ), ]);
        controls?.userDisableDaysThreshold?.markAsDirty();
        controls?.userDisableDaysThreshold?.updateValueAndValidity();
    }

    validateAllowedDomains(domains: string): boolean {
        const domainList = domains?.length
            ? domains?.split(',')?.map((domainVal) => domainVal?.trim())
            : [];

        if (domainList?.length > 64) {
            this.toast?.warn(`Max 64 different domains can be added!`);
            return;
        }

        if (!domainList?.length) return true;
        const pattern =
            /^[a-zA-Z0-9][a-zA-Z0-9-]{0,28}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/;
        for (const domainVal of domainList)
            if (!pattern.test(domainVal)) {
                this.toast.warn(`Domain ${domainVal} is invalid!`);
                return false;
            }
        return true;
    }

    updateDomainSettings(
        form: NgForm,
        cancelBtn: HTMLButtonElement,
        closeSettingsOffcanvasBtn: HTMLButtonElement
    ): void {
        this.toast?.clear();
        if (!this.validateAllowedDomains(form?.value?.allowedDomain as string))
            return;

        if (form?.invalid) {
            this.toast?.warn('Please fill all the required fields!');
            return;
        }
        const formObj = form?.value as DOMAIN_SETTINGS;
        formObj['allowedDomain'] = form?.value?.allowedDomain
            ?.split(',')
            ?.map((domainVal) => domainVal?.trim())
            ?.join(',');
        const booleanFlags: string[] = [DOMAIN_CONFIG.MFA_VERIFICATION_REQUIRED, DOMAIN_CONFIG.VERIFICATION_REQUIRED];
        booleanFlags?.forEach((flag)=> formObj[flag] = !!formObj?.[flag]);
        this.organisationService
            ?.updateDomainSettings(
                formObj,
                this.authService?.currentUser?.domainId as number,
                'domain'
            )
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: () => {
                    cancelBtn?.click();
                    closeSettingsOffcanvasBtn?.click();
                    this.getDomainDetails();
                    this.getUsers();
                },
                error: () => {
                    cancelBtn?.click();
                },
            });
    }

    getUserVerificationReport(): void {
        window.open(
            this.organisationService?.getUserVerificationReport(),
            '_blank'
        );
    }

    uploadUserVerificationFile(csvSpy: any, closeBtn: HTMLButtonElement): void {
        this.toast?.clear();
        const csvFile = csvSpy.valueAccessor._elementRef.nativeElement.files;
        if (!csvFile.length) {
            this.toast?.warn('CSV file is required!');
            return;
        }

        const fileExtension = csvFile[0].name.substring(
            csvFile[0].name.lastIndexOf('.') + 1
        );

        if (fileExtension.toLowerCase() !== 'csv') {
            this.toast?.warn('Only .csv format is supported!');
            return;
        }

        const formDataObj = new FormData();
        formDataObj.append('file', csvFile[0] as string);

        this.organisationService
            ?.uploadUserVerificationMigrationFile(formDataObj)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: Blob) => {
                    const downloadLink = document.createElement('a');
                    const blobData = new Blob([response], {
                        type: 'application/octet-stream',
                    });
                    downloadLink.href = window.URL.createObjectURL(blobData);
                    downloadLink.setAttribute(
                        'download',
                        'user-migration-results.csv'
                    );
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    downloadLink.parentNode.removeChild(downloadLink);
                    closeBtn?.click();
                },
            });
    }

    bulkAddUserRoles(csvSpy: any, closeBtn: HTMLButtonElement): void {
        this.toast?.clear();
        const csvFile = csvSpy.valueAccessor._elementRef.nativeElement.files;
        if (!csvFile.length) {
            this.toast?.warn('CSV file is required!');
            return;
        }

        const fileExtension = csvFile[0].name.substring(
            csvFile[0].name.lastIndexOf('.') + 1
        );

        if (fileExtension.toLowerCase() !== 'csv') {
            this.toast?.warn('Only .csv format is supported!');
            return;
        }

        const formDataObj = new FormData();
        formDataObj.append('file', csvFile[0] as string);

        this.userService
            .bulkAddUserRoles(formDataObj, this.domainId, this.flow)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    this.toast?.success('Roles added successfully!');
                    this.selectedUserStatus === 'admin' ? this.getUsersForAdminTab() : this.getUsers();
                    const downloadLink = document.createElement('a');
                    const blobData = new Blob([response], {
                        type: 'application/octet-stream',
                    });
                    downloadLink.href = window.URL.createObjectURL(blobData);
                    downloadLink.setAttribute(
                        'download',
                        'bulk-add-users-roles-results.csv'
                    );
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    downloadLink.parentNode.removeChild(downloadLink);
                    closeBtn?.click();
                },
            });
    }

    bulkAddUsers(csvSpy: any, closeBtn: HTMLButtonElement): void {
        this.toast?.clear();

        const csvFile = csvSpy.valueAccessor._elementRef.nativeElement.files;
        if (!csvFile.length) {
            this.toast?.warn('CSV file is required!');
            return;
        }

        const fileExtension = csvFile[0].name.substring(
            csvFile[0].name.lastIndexOf('.') + 1
        );

        if (fileExtension.toLowerCase() !== 'csv') {
            this.toast?.warn('Only .csv format is supported!');
            return;
        }

        const formDataObj = new FormData();
        formDataObj.append('file', csvFile[0] as string);

        this.userService
            .bulkAddUsers(formDataObj, this.domainId, this.flow)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    this.toast?.success('Users added successfully!');
                    this.selectedUserStatus === 'admin' ? this.getUsersForAdminTab() : this.getUsers();

                    const downloadLink = document.createElement('a');
                    const blobData = new Blob([response], {
                        type: 'application/octet-stream',
                    });
                    downloadLink.href = window.URL.createObjectURL(blobData);
                    downloadLink.setAttribute(
                        'download',
                        'bulk-add-users-remarks.csv'
                    );
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    downloadLink.parentNode.removeChild(downloadLink);
                    closeBtn?.click();
                },
            });
    }

    downloadUserDetailsReport(): void {
        this.toast?.clear();
        if(!this.domainId) {
            this.toast.warn('Organisation is required!');
            return;
        }
        this.userService.getUserDetailsReport(this.domainId, this.flow)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response)=> {
                    const downloadLink = document.createElement('a');
                    const blobData = new Blob([response], {
                        type: 'application/octet-stream',
                    });
                    downloadLink.href = window.URL.createObjectURL(blobData);
                    downloadLink.setAttribute(
                        'download',
                        `${this.flow}-user-details-report.csv`
                    );
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    downloadLink.parentNode.removeChild(downloadLink);
                },
            });
    }

    setAddDomainResourceModalData(): void {
        this.addDomainResourceModalConfig = new MODALCONFIG({
            selector: 'add-domain-resource-modal',
            heading: 'Add Domain Resource',
            icon: 'plus',
            theme: 'teal',
            size: MODAL_SIZE.MD,
            displayDefaultFooterContent: true,
            submitAction: this.createDomainResource.bind(this),
        });

        this.addDomainResourceFormModel = {
            resourceId: {
                type: FIELD_TYPE.SELECT,
                options: [],
                key: 'resourceId',
                label: 'Resource Type',
                containerClass: 'col-12 col-md-6',
            },
            value: {
                type: FIELD_TYPE.TEXT,
                key: 'value',
                label: 'Value',
                containerClass: 'col-12 col-md-6',
            },
            description: {
                type: FIELD_TYPE.TEXTAREA,
                key: 'description',
                label: 'Description',
                containerClass: 'col-12',
            },
        };
    }

    setAddNewUserModalData(): void {
        this.addNewUserModalConfig = new MODALCONFIG({
            selector: 'add-new-user-modal',
            heading: 'Add New User',
            icon: 'plus',
            theme: 'teal',
            size: MODAL_SIZE.MD,
            displayDefaultFooterContent: false,
            submitAction: this.addNewUser.bind(this),
        });

        this.addNewUserBasicDetailsFormModel = {
            appName: {
                type: FIELD_TYPE.TEXT,
                key: 'appName',
                label: 'Application',
                containerClass: 'col-12 col-md-6',
                disabled: true,
                toBeShown: this.flow === 'admin' ? true : false,
            },
            domain: {
                type: FIELD_TYPE.TEXT,
                key: 'domain',
                label: 'Domain',
                containerClass: 'col-12 col-md-6',
                disabled: true,
                toBeShown: this.flow === 'admin' ? true : false,
            },
            fullName: {
                type: FIELD_TYPE.TEXT,
                key: 'fullName',
                label: 'Full Name',
                containerClass: 'col-12 col-md-6',
            },
            username: {
                type: FIELD_TYPE.TEXT,
                key: 'username',
                label: 'Username',
                containerClass: 'col-12 col-md-6',
            },
            email: {
                type: FIELD_TYPE.EMAIL,
                key: 'email',
                label: 'Email',
                containerClass: 'col-12 col-md-6',
            },
            phone: {
                type: FIELD_TYPE.TEXT,
                inputMode: INPUT_MODE.NUMERIC,
                key: 'phone',
                label: 'Contact',
                containerClass: 'col-12 col-md-6',
                minAttr: 10,
                maxAttr: 10,
            },
        };

        this.addNewUserPasswordFormModel = {
            password: {
                type: FIELD_TYPE.PASSWORD,
                key: 'password',
                label: 'Password',
                containerClass: 'col-12 col-md-6',
                pattern: PASSWORD_SETTINGS.PATTERN,
                minAttr: 10,
                showConfirmation: true,
            },
        };
    }

    setBulkUserDeletionModalData(): void {
        this.bulkUserDeletionModalConfig = new MODALCONFIG({
            selector: 'bulk-user-deletion-modal',
            type: MODAL_TYPE.FORM,
            heading: 'Bulk User Deletion',
            theme: 'danger',
            icon: 'alert-circle',
            size: MODAL_SIZE.MD,
            displayDefaultFooterContent: false,
            // submitAction: this.changeUserState.bind(this)
        });
    }

    setChangeUserStateModalData(): void {
        this.enableUserStateModalConfig = new MODALCONFIG({
            selector: 'enable-user-state-modal',
            type: MODAL_TYPE.CONFIRM,
            heading: 'Confirmation',
            theme: 'teal',
            icon: 'alert-circle',
            size: MODAL_SIZE.MD,
            displayDefaultFooterContent: true,
            submitAction: this.changeUserState.bind(this),
        });

        this.disableUserStateModalConfig = new MODALCONFIG({
            selector: 'disable-user-state-modal',
            type: MODAL_TYPE.CONFIRM,
            heading: 'Confirmation',
            theme: 'danger',
            icon: 'alert-circle',
            size: MODAL_SIZE.MD,
            displayDefaultFooterContent: true,
            submitAction: this.changeUserState.bind(this),
        });
    }

    setChangeUserVerificationStatusModalData(): void {
        this.enableUserVerificationStatusModalConfig = new MODALCONFIG({
            selector: 'enable-user-verification-status-modal',
            type: MODAL_TYPE.CONFIRM,
            heading: 'Confirmation',
            theme: 'teal',
            icon: 'alert-circle',
            size: MODAL_SIZE.MD,
            displayDefaultFooterContent: true,
            submitAction: this.changeUserVerificationStatus.bind(this),
        });
        this.disableUserVerificationStatusModalConfig = new MODALCONFIG({
            selector: 'disable-user-verification-status-modal',
            type: MODAL_TYPE.CONFIRM,
            heading: 'Confirmation',
            theme: 'danger',
            icon: 'alert-circle',
            size: MODAL_SIZE.MD,
            displayDefaultFooterContent: true,
            submitAction: this.changeUserVerificationStatus.bind(this),
        });
    }

    setChangeUserMFAStatusModalData(): void {
        this.enabledUserMFAStatusModalConfig = new MODALCONFIG({
            selector: 'enable-user-mfa-status-modal',
            type: MODAL_TYPE.CONFIRM,
            heading: 'Confirmation',
            theme: 'teal',
            icon: 'alert-circle',
            size: MODAL_SIZE.MD,
            displayDefaultFooterContent: true,
            submitAction: this.changeUserMFAStatus.bind(this),
        });
        this.disableUserMFAStatusModalConfig = new MODALCONFIG({
            selector: 'disable-user-mfa-status-modal',
            type: MODAL_TYPE.CONFIRM,
            heading: 'Confirmation',
            theme: 'danger',
            icon: 'alert-circle',
            size: MODAL_SIZE.MD,
            displayDefaultFooterContent: true,
            submitAction: this.changeUserMFAStatus.bind(this),
        });
    }

    changeUserStateModalDataModification(switchSpy: HTMLInputElement): void {
        switchSpy.checked = !switchSpy?.checked;
        this.enableUserStateModalConfig.pillData = this.selectedUser?.fullName;
        this.disableUserStateModalConfig.pillData = this.selectedUser?.fullName;
    }

    changeUserVerificationStatusDataModification(
        switchSpy: HTMLInputElement,
        verificationStatus: USER['verificationStatus']
    ): void {
        switchSpy.checked = !switchSpy?.checked;
        this.enableUserVerificationStatusModalConfig['pillData'] =
            this.disableUserVerificationStatusModalConfig['pillData'] =
                this.selectedUser?.fullName;

        if (verificationStatus === 'VERIFIED')
            this.toast?.warn(
                'User is already Verified. Email Verification cannot be turned off for this user!'
            );
    }

    changeUserMFAStatusDataModification(
        switchSpy: HTMLInputElement,
        userMfaEnabled: boolean,
        domainMFAVerificationRequired: boolean
    ): void {
        switchSpy.checked = !switchSpy?.checked;
        this.enabledUserMFAStatusModalConfig['pillData'] =
            this.disableUserMFAStatusModalConfig['pillData'] =
                this.selectedUser?.fullName;

        if (!!userMfaEnabled && !!domainMFAVerificationRequired){
            this.toast?.warn(
                'MFA is turned on for this Organisation. MFA cannot be turned off for this user!'
            );
            return;
        }
    }

    getLoginModeSelectOptions(): void {
        this.loginModes?.forEach((loginMode) =>
            loginMode?.value !== 'system'
                ? this.loginModeSelectOptions?.push({
                    displayKey: loginMode?.key,
                    valueKey: loginMode?.value,
                })
                : ''
        );
    }

    setUpdateUserDetailsModalData(): void {
        this.updateUserDetailsModalConfig = new MODALCONFIG({
            selector: 'update-user-details-modal',
            heading: 'Update User Details',
            icon: 'pencil',
            theme: 'primary',
            size: MODAL_SIZE.MD,
            displayDefaultFooterContent: true,
            submitAction: this.updateUserDetails.bind(this),
        });

        this.updateUserDetailsFormModel = {
            fullName: {
                type: FIELD_TYPE.TEXT,
                key: 'fullName',
                label: 'Full Name',
                containerClass: 'col-12 col-md-6',
            },
            email: {
                type: FIELD_TYPE.EMAIL,
                key: 'email',
                label: 'Email',
                containerClass: 'col-12 col-md-6',
            },
            phone: {
                type: FIELD_TYPE.TEXT,
                inputMode: INPUT_MODE.NUMERIC,
                key: 'phone',
                label: 'Contact',
                containerClass: 'col-12 col-md-6',
                minAttr: 10,
                maxAttr: 10,
            },
        };
    }

    setManageUserLoginModeModalData() {
        this.manageUserLoginModeModalConfig = new MODALCONFIG({
            selector: 'manage-user-login-mode-modal',
            heading: 'Manage Login Mode',
            theme: 'accent',
            icon: 'account-cog',
            size: MODAL_SIZE.MD,
            displayDefaultFooterContent: false,
            // submitAction: this.changeUserLoginMode.bind(this, this.manageLoginModeSelectSpy)
        });

        this.manageUserLoginModeFormModel = {
            password: {
                type: FIELD_TYPE.PASSWORD,
                key: 'password',
                label: 'Password',
                containerClass: 'col-12 col-md-6',
                pattern: PASSWORD_SETTINGS.PATTERN,
                minAttr: 10,
                showConfirmation: true,
            },
        };
    }

    setChangeUserPasswordModalData(): void {
        this.changeUserPasswordModalConfig = new MODALCONFIG({
            selector: 'change-user-password-modal',
            heading: 'Change Password',
            theme: 'danger',
            icon: 'lock-open',
            size: MODAL_SIZE.MD,
            displayDefaultFooterContent: true,
            submitAction: this.changeUserPassword.bind(this),
        });

        this.changeUserPasswordFormModel = {
            password: {
                type: FIELD_TYPE.PASSWORD,
                key: 'password',
                label: 'Password',
                containerClass: 'col-12 col-md-6',
                pattern: PASSWORD_SETTINGS.PATTERN,
                minAttr: 10,
                showConfirmation: true,
            },
        };
    }

    setResetUserModalData(): void {
        this.resetUserModalConfig = new MODALCONFIG({
            selector: 'reset-user-modal',
            heading: 'Reset User',
            type: MODAL_TYPE.CONFIRM,
            theme: 'teal',
            displayDefaultFooterContent: true,
            icon: 'backup-restore',
            size: MODAL_SIZE.MD,
            submitAction: this.resetUser.bind(this),
        });
    }

    setRoleManagementModalData(): void {
        this.roleManagementModalConfig = new MODALCONFIG({
            selector: 'role-management-modal',
            heading: 'Role Management',
            theme: 'primary',
            size: MODAL_SIZE.MD,
            displayDefaultFooterContent: true,
            // scrollable: false
        });
    }

    setDomainSettingsModalData(largeScreen: boolean = true): void {
        this.domainSettingsModalConfig = new SIDEDRAWERCONFIG({
            selector: 'domain-settings-modal',
            heading: 'Domain Settings',
            icon: 'cog',
            theme: 'primary',
            autoFocus: false,
            type: SIDEDRAWER_TYPE.CONFIRM,
            size: largeScreen ? SIDEDRAWER_SIZE.LG : SIDEDRAWER_SIZE.FS,
            position: largeScreen
                ? SIDEDRAWER_POSITION.RIGHT
                : SIDEDRAWER_POSITION.BOTTOM,
            displayDefaultFooterContent: false,
            submitAction: this.updateDomainSettings.bind(this),
        });

        this.domainSettingsConfirmationModalConfig = new MODALCONFIG({
            selector: 'domain-settings-confirmation-modal',
            heading: 'Confirm Settings',
            enableBackdrop: true,
            type: MODAL_TYPE.CONFIRM,
            theme: 'success',
            icon: 'check-bold',
            size: MODAL_SIZE.MD,
            displayDefaultFooterContent: false,
        });
    }

    setBulkAddUsersModalData(): void {
        this.bulkAddUsersModalConfig = new MODALCONFIG({
            selector: 'bulk-add-users-modal',
            heading: 'Bulk Add Users',
            enableBackdrop: false,
            type: MODAL_TYPE.CONFIRM,
            scrollable: true,
            theme: 'success',
            icon: 'folder-plus-outline',
            size: MODAL_SIZE.MD,
            displayDefaultFooterContent: false
        });

        this.bulkAddUsersRolesModalConfig = new MODALCONFIG({
            selector: 'bulk-add-users-roles-modal',
            heading: 'Bulk Add Roles',
            enableBackdrop: false,
            type: MODAL_TYPE.CONFIRM,
            scrollable: true,
            theme: 'primary-dark',
            icon: 'cloud-upload',
            size: MODAL_SIZE.MD,
            displayDefaultFooterContent: false,
        });
    }

    focusElem(spy, timeout?: number) {
        setTimeout(
            () => spy?.valueAccessor?._elementRef?.nativeElement?.select(),
            timeout
        );
    }

    // To be replaced with increff commons service

    initPopover(): void {
        this.helperService?.initPopover('com-users');
    }

    ngOnDestroy(): void {
        this.managementService.appNamesMap = {};
    }
}
